import { load, ReCaptchaInstance } from "recaptcha-v3";
import type { IRenderParameters } from "recaptcha-v3/dist/grecaptcha/grecaptcha";

export default class RecaptchaService {
  private recaptcha: ReCaptchaInstance | null = null;
  private initPromise: Promise<ReCaptchaInstance> | null = null;

  protected siteKeyV3: string;
  protected siteKeyV2: string;

  protected v2WidgetId: string | null = null;

  constructor(siteKeyV3: string, siteKeyV2: string) {
    this.siteKeyV3 = siteKeyV3;
    this.siteKeyV2 = siteKeyV2;
  }

  public async init(): Promise<ReCaptchaInstance> {
    if (!this.initPromise) {
      this.initPromise = load(this.siteKeyV3).then((instance) => {
        this.recaptcha = instance;
        return instance;
      });
    }

    return this.initPromise;
  }

  public async getToken(action: string): Promise<string> {
    if (!this.recaptcha) {
      await this.init();
    }

    return this.recaptcha.execute(action);
  }

  public initV2(
    containerId: string,
    tokenCallback: (token: string) => void,
    expiredCallback: (expired: boolean) => void
  ): void {
    this.v2WidgetId = grecaptcha.render(containerId, {
      sitekey: this.siteKeyV2,
      callback: (token: string) => {
        tokenCallback(token);
        expiredCallback(false);
      },
      "expired-callback": () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        grecaptcha.reset(this.v2WidgetId); //! ⬅️ reset only this widget
        tokenCallback("");
        expiredCallback(true);
      },
    } as IRenderParameters);
  }
}
